<div class="plugin">
  <!-- <script>
    var OaP = {
      CarrierId: 484,
      ProductTypeId: 3,
      UserLogin: 'test',
      ContactEmail: 'test@test.fr',
      ContactFirstName: 'test',
      ContactLastName: 'test',
      ContactPhone: '0600000000',
      IsCarrierContactAccept: false,
      CarrierExternalId: '0'
    };
    loggerService.log(OaP);
  </script> -->
  <div id="OpinionAssurancesPlugin"></div>
  <!-- <script
    id="OpinionAssurancesPlugin"
    name="3a1aa2c00b6c2e4ad135791a845a5298"
    src="https://d2x33sw8v4ayed.cloudfront.net/resource/js/plugin.js"
    type="text/javascript"
  ></script> -->
</div>
